import { render } from "./InfoMng.vue?vue&type=template&id=13ab485b&scoped=true"
import script from "./InfoMng.vue?vue&type=script&lang=js"
export * from "./InfoMng.vue?vue&type=script&lang=js"

import "./InfoMng.vue?vue&type=style&index=0&id=13ab485b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ab485b"]])

export default __exports__